/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { setShowExcelUploadErrors } from 'redux/actions';

export const UploadErrorModal = ({
  libraryType,
  openExcelUploadErrors,
  setOpenExcelUploadErrors,
}) => {
  const dispatch = useDispatch();

  const excelUploadErrors = useSelector(
    (state) => state.dataReducers.excelUploadErrors
  );
  const showUploadError = useSelector(
    (state) => state.dataReducers.showUploadError
  );

  const [uploadErrors, setUploadErrors] = useState([]);

  useEffect(() => {
    if (showUploadError === 'show') {
      dispatch(setShowExcelUploadErrors('visited'));
    }
  }, [showUploadError]);

  useEffect(() => {
    const uploadErrors = excelUploadErrors.filter((item) => {
      if (item.error.length !== 0) {
        return item;
      }
    });
    setUploadErrors(uploadErrors);
  }, [excelUploadErrors, showUploadError]);

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: 'red' }} /> Error
        </span>
      }
      onCancel={() => {
        setOpenExcelUploadErrors(false);
      }}
      visible={libraryType === 'user' && openExcelUploadErrors}
      footer={[
        <Button
          key='cancel'
          onClick={() => {
            setOpenExcelUploadErrors(false);
          }}
        >
          Close
        </Button>,
      ]}
    >
      <p>
        The following SPD's failed to execute. Please check the input and try
        again.
      </p>
      <div css={tableContainerStyles}>
        <table css={errorTableStyles}>
          <thead>
            <tr>
              <th>SPD</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            {uploadErrors.map((error) => (
              <tr>
                <td>{error.identifier}</td>
                <td>
                  <p key={error.id}>{error.error}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

const tableContainerStyles = css`
  max-height: 50rem;
  overflow-y: auto;
`;

const errorTableStyles = css`
  width: 100%;
  height: 10rem;
  border: 2px solid black;

  th {
    position: sticky;
    top: 0;
    background: #dddddd;
  }

  th,
  td {
    border: 2px solid black;
    text-align: center;
    padding: 10px;
  }

  p {
    text-align: left;
  }
`;
